module.exports = __webpack_public_path__ + "resources/img/img_secure_center02_en.cbfe8dfe5e9c5b78815304b2c8f27729.png";